import aa from 'search-insights'

aa('init', {
  appId: 'U4BSY5DLQ2',
  apiKey: '66399ac86f44c8e9016199bae1d7b369',
})

export default aa
